import { Component, HostBinding, Input } from '@angular/core';
import { AbstractComponent } from '../../abstract.component';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { SolIconComponent } from '../sol-icon/sol-icon.component';
import { SolValidationType } from '../../../models/core/sol-validation-type';
import { SolText } from '../../../models/core/sol-text';
import { SolValidationMessage } from '../../../models/core/sol-validation-message';
import { SolAlert } from '../../../models/core/sol-alert';

@Component({
  selector: 'sol-alert',
  imports: [SolIconComponent, TranslatePipe],
  templateUrl: './sol-alert.component.html',
  host: { role: 'alert' },
})
export class SolAlertComponent extends AbstractComponent<SolAlert> {
  // Computed
  protected readonly hostClass$ = this.compute(state => state.hostClass);
  protected readonly icon$ = this.compute(state => state.icon);
  protected readonly text$ = this.compute(state => state.text);
  protected readonly info$ = this.compute(state => state.info);
  protected readonly custom$ = this.compute(state => state.custom);
  protected readonly truncated$ = this.compute(state => state.truncated);

  constructor() {
    super(SolAlert.of());
  }

  @HostBinding('class')
  public get hostClass(): string {
    return this.hostClass$();
  }

  @Input()
  public set alert(alert: SolAlert) {
    this.patch(alert);
  }

  @Input()
  public set type(type: SolValidationType) {
    this.update(state => state.withType(type));
  }

  @Input()
  public set text(text: SolText) {
    this.update(state => state.withText(text));
  }

  @Input()
  public set info(info: SolText | undefined) {
    this.update(state => state.withInfo(info));
  }

  @Input()
  public set messages(messages: SolValidationMessage[]) {
    this.update(state => state.withMessages(messages));
  }

  @Input()
  public set custom(custom: boolean) {
    this.update(state => state.withCustom(custom));
  }

  @Input()
  public set inline(inline: boolean) {
    this.update(state => state.withInline(inline));
  }

  @Input()
  public set truncated(truncated: boolean) {
    this.update(state => state.withTruncated(truncated));
  }
}
